import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import resourceSubject from '../reactivity/resource-subject';

Component('tr-project-timeline-trigger', {
  ready() {
    console.debug('trigger project_timeline_view_show');
    $(() => {
      resourceSubject('user-guide').next('project_timeline_view_show', {});
    });
  },
  beforeCache() {
    this.remove();
  },
});
